export default "__VITE_ASSET__DGTo3OSK__"